import { TFunction } from 'i18next';

export default function getVersionActionLabel(
  versionNumber: number | null | undefined,
  t: TFunction<'translation', undefined>,
): string {
  return versionNumber === 1 ? t('document-created') : t('version-updated');
}
